import { render } from "./DraftJobsIcon.vue?vue&type=template&id=322f7aee"
import script from "./DraftJobsIcon.vue?vue&type=script&lang=js"
export * from "./DraftJobsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__